/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Remove_FontInputs */

const en_options_fonts_remove_font = /** @type {(inputs: Options_Fonts_Remove_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Font`)
};

const fr_options_fonts_remove_font = /** @type {(inputs: Options_Fonts_Remove_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la police`)
};

const de_options_fonts_remove_font = /** @type {(inputs: Options_Fonts_Remove_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftart entfernen`)
};

const it_options_fonts_remove_font = /** @type {(inputs: Options_Fonts_Remove_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi carattere`)
};

const ru_options_fonts_remove_font = /** @type {(inputs: Options_Fonts_Remove_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить шрифт`)
};

const es_options_fonts_remove_font = /** @type {(inputs: Options_Fonts_Remove_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar fuente`)
};

const zh_cn2_options_fonts_remove_font = /** @type {(inputs: Options_Fonts_Remove_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除字体`)
};

const ja_options_fonts_remove_font = /** @type {(inputs: Options_Fonts_Remove_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォントを削除`)
};

const hi_options_fonts_remove_font = /** @type {(inputs: Options_Fonts_Remove_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉन्ट हटाएँ`)
};

const pt_pt2_options_fonts_remove_font = /** @type {(inputs: Options_Fonts_Remove_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover fonte`)
};

/**
* | output |
* | --- |
* | "Remove Font" |
*
* @param {Options_Fonts_Remove_FontInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_remove_font = /** @type {((inputs?: Options_Fonts_Remove_FontInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Remove_FontInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_fonts_remove_font(inputs)
	if (locale === "de") return de_options_fonts_remove_font(inputs)
	if (locale === "it") return it_options_fonts_remove_font(inputs)
	if (locale === "ru") return ru_options_fonts_remove_font(inputs)
	if (locale === "es") return es_options_fonts_remove_font(inputs)
	if (locale === "zh-CN") return zh_cn2_options_fonts_remove_font(inputs)
	if (locale === "ja") return ja_options_fonts_remove_font(inputs)
	if (locale === "hi") return hi_options_fonts_remove_font(inputs)
	if (locale === "pt-PT") return pt_pt2_options_fonts_remove_font(inputs)
	return en_options_fonts_remove_font(inputs)
});